import { render, staticRenderFns } from "./recLogin.vue?vue&type=template&id=09fbb245&"
import script from "./recLogin.vue?vue&type=script&lang=js&"
export * from "./recLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports